import { Model } from './model';

export class Text extends Model<Text> {
  name: string;
  CreatorId: number;
  html: string;
  customerAccess: boolean;
}
